import { z } from 'zod';
import { createZodDto } from 'nestjs-zod';

export const measurement = z.object({
  identifier: z.string().uuid(),
  timestamp: z.date(),
});

export class Measurement extends createZodDto(measurement) {}
